export default __webpack_public_path__ + "static/media/Communities_W.fb76907b.png";